import React, { useState, useEffect, useRef } from "react";
import { Input, Select, Button, message, Modal, Menu } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TreeMenu from "./TreeMenu/TreeMenu";

import flowData from "./dataJson/flowData.json";
import {LoadingOutlined} from "@ant-design/icons";
import userInfo from "@/Components/user";

interface TreeFrameProps {
  dataSource: any;
  treeData:any;
  flowChartType:string;
  selectTaskData:any;
  selectDesignData:any;
  handleSelectVariable?:any;
  runNodes:any
  setSubName?:(newSubName)=>void;
  setCurResultInfo?:any;
  setResultDrawOpen?:any;
  openParamsModal:()=>void;
  setSelectedElementData:(node)=>void;
  runPartTask:(node) =>void;
  runGroupTask:(node) =>void;
  setClearAllNodeIconHighVariable:()=>void;
  setClearAllLinkHighVariable:()=>void;
  setClearAllGroupHighVariable:()=>void;
  setCenterElement:(centerElement)=>void;
  setImportDataType:(newImportDataType)=>void;
}

const TreeFrame: React.FC<TreeFrameProps> = ({
  dataSource,
  treeData,
  flowChartType,
  selectTaskData,
  selectDesignData,
  handleSelectVariable,
  runNodes,
  setSubName,
  setCurResultInfo,
  setResultDrawOpen,
  openParamsModal,
  setSelectedElementData,
  runPartTask,
  runGroupTask,
  setClearAllNodeIconHighVariable,
  setClearAllLinkHighVariable,
  setClearAllGroupHighVariable,
  setCenterElement,
  setImportDataType,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedItem, setSelectedItem] = useState(null);

  //新变量
  const projectId = 138;  //项目ID
  const flowId = 532; //流程ID
  const token = userInfo.access_token;  //调用接口的token

  return (
    <>
      {contextHolder}
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          border: "1px solid #BBB",
          backgroundColor: "rgb(241, 238, 238)",
          overflowX: "hidden",
        }}
      >
        <TreeMenu
          data={treeData}
          dataSource={dataSource}
          selectedNode={selectedItem}
          setSelectedNode={setSelectedItem}
          flowChartType={flowChartType}
          selectTaskData={selectTaskData}
          setSubName={(newSubName)=>{setSubName(newSubName);}}
          setCurResultInfo={setCurResultInfo}
          setResultDrawOpen={setResultDrawOpen}
          openParamsModal={()=>{openParamsModal();}}
          handleSelectVariable={handleSelectVariable}
          setSelectedElementData={(node)=>{setSelectedElementData(node);}}
          runPartTask={(node)=>{runPartTask(node);}}
          runGroupTask={(node)=>{runGroupTask(node);}}
          setClearAllNodeIconHighVariable={()=>{setClearAllNodeIconHighVariable();}}
          setClearAllLinkHighVariable={()=>{setClearAllLinkHighVariable();}}
          setClearAllGroupHighVariable={()=>{setClearAllGroupHighVariable();}}
          setCenterElement={(centerElement)=>{setCenterElement(centerElement);}}
          setImportDataType={(newImportDataType)=>{setImportDataType(newImportDataType);}}
          runNodes={runNodes}
        />
      </div>
    </>
  );
};

export default TreeFrame;
